import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { FREE, STARTER } from 'self-service-api/constants/ProductLevels';
import { HighlightedProductsHeaderConfig } from '../../../constants/merchCards/HighlightedProductsHeaderConfig';
import { isUngatedForInbound25Selector } from '../../../selectors/GatingSelectors';
import { useAppSelector } from '../../../reducers';
import { jsx as _jsx } from "react/jsx-runtime";
export const StandardLowerTierMessage = ({
  productLine,
  productLevel,
  handleClick,
  isFreePortal
}) => {
  // TODO - these translations are all coming from SSAPI, migrate to new format
  const config = HighlightedProductsHeaderConfig[productLine][productLevel];
  const isUngatedForInbound25 = useAppSelector(isUngatedForInbound25Selector);
  const lowerTierPlus = isUngatedForInbound25 ? (config === null || config === void 0 ? void 0 : config.lowerTierPlusInbound25) || '' : (config === null || config === void 0 ? void 0 : config.lowerTierPlus) || '';
  if (productLevel === FREE) {
    return /*#__PURE__*/_jsx(Link, {
      onClick: handleClick,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "merchCards.priorityFeatures.includes"
      })
    });
  }
  if (productLevel === STARTER && isFreePortal) {
    return isUngatedForInbound25 ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.merchCardsV2.priorityFeatures.freeToolsPlusInbound25"
    }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "merchCards.priorityFeatures.freeToolsPlus",
      options: {
        freeToolsWithIncreasedLimits: /*#__PURE__*/_jsx(Link, {
          onClick: handleClick,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "merchCards.priorityFeatures.freeToolsWithLimits"
          })
        })
      }
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: lowerTierPlus
  });
};